import { render } from "./ReportLowStock.vue?vue&type=template&id=032b696e"
import script from "./ReportLowStock.vue?vue&type=script&lang=js"
export * from "./ReportLowStock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__